<template>
  <span>
    <div id="app">
      
      <app-nav v-if="instrumentState.db || instrumentState.isLanding"></app-nav>

      <landing v-if="!loading && !instrumentState.db && instrumentState.isLanding"></landing>
      <div class="container">
        <a v-if="loading" class="button is-loading is-text is-large is-fullwidth" style="font-size: 3em;"></a>
        <login v-if="!loading && !instrumentState.db && !instrumentState.isLanding" v-on:check_login="checkLogin"></login>
        <router-view v-if="!loading && instrumentState.db"></router-view>
      </div>


      <!-- #Politica privacidade -->
      <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.privacidade ? 'is-active' : ''">
        <div class="modal-background"></div>
        <div class="modal-content" style="width: 80%;">
          <div class="box" style="padding: 10px;">

            <object data="https://www.ipt.br/politica_de_privacidade.php" style="width: 100%;height: 80vh;overflow-y: hidden;"> <embed src="https://www.ipt.br/politica_de_privacidade.php"></embed></object>

          </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="instrumentState.modals.privacidade = false"></button>
      </div>
      <!-- /Politica privacidade -->


    </div>
    <div id="pdf-container"></div>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">
    <link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet" type="text/css"/>
  </span>
</template>
<script>
import AppNav from '@/components/AppNav.vue'
import Landing from '@/components/Landing.vue'
import Login from '@/components/Login.vue'
import Instrumentos from '@/components/Instrumentos.vue'
import _ from 'lodash'
import {fnSignformatter,
fnHideOnClickOutside,
fnRegreArray,
fnPegaDataUTCNum,
fnTextoEntreTags,
fnFmtData,
fnCampoValidoParaExibicao,
fnDescItem,
fnPegaStatus,
fnPegaStatusChecagem,
fnQueryInstIdData,
fnConfigPeriodicidade} from './fn'

window.T = {
  'global': 'Análise Global',
  'fatorMultiplicativo': 'Fator',
  'aplicarCorrecao': 'Corrigir',
  'lhs': 'EMA',
  'calculoEscolha': 'Cálculo',
  'periodicidade': 'Periodicidade',
  'tolVal': 'Valor da Tolerância relativa',
  'tolUnidade': 'Unidade da Tolerância relativa',
  'tolValNaUnidade': 'Valor da Tolerância na Unidade',
  'true': 'Verdadeiro',
  'false': 'Falso',
  'tol': 'Personalizado',
  'ema': 'Certificado de Calibração'
}

window.addEventListener('online',function(){INSTRUMENT_STORE.state.online = true;console.log('online')})
window.addEventListener('offline',function(){INSTRUMENT_STORE.state.online = false})

import {Analises} from './analises'

import {INSTRUMENT_STORE} from './instrumentStore'
window.INSTRUMENT_STORE = INSTRUMENT_STORE
const state = INSTRUMENT_STORE.state

import axios from 'axios'
import PouchDB from 'pouchdb'
import pouchAuth from 'pouchdb-authentication'
PouchDB.plugin(pouchAuth);


var complementoPageView = function () {
  if (INSTRUMENT_STORE.state.userCtx) {
    return ' - ' + INSTRUMENT_STORE.state.userCtx.name
  }
  return ''
}


export default {
  name: 'App',
  components: {AppNav, Landing, Login, Instrumentos},
  watch: {
    'instrumentState.descItem': function() {
      document.title = 'ProCal - ' + this.instrumentState.descItem// + complementoPageView()
    },
    '$route.query.modal': function(val) {
      if (!val) {
        Object.keys(this.instrumentState.modals).map((k) => {
          this.instrumentState.modals[k] = false
        })
        Object.assign(document.body.style, {
            marginRight: '0px'
        });
      } else {
        var elements = document.getElementsByClassName('modal-background')
        for (var i = 0; i < elements.length; i++) {
          elements[i].onclick = () => {
            Object.keys(this.instrumentState.modals).map((k) => {
              this.instrumentState.modals[k] = false
            })
          }
        }
      }

    },
    'instrumentState.modals': {
      handler: function (val) {
        
        var q = _.clone(this.$route.query)
        
        let marginRightPx = 0;
        if(window.getComputedStyle) {
            let bodyStyle = window.getComputedStyle(document.body);
            if(bodyStyle) {
                marginRightPx = parseInt(bodyStyle.marginRight, 10);
            }
        }

        let scrollbarWidthPx = window.innerWidth - document.body.clientWidth;
        Object.assign(document.body.style, {
            overflow: 'hidden',
            marginRight: `${marginRightPx + scrollbarWidthPx}px`
        });

        if (this.temModalAberto) {
          document.body.parentElement.style.overflow = 'hidden'
          q.modal = this.temModalAberto
        } else {
          document.body.parentElement.style.overflow = ''
          delete q.modal
          Object.assign(document.body.style, {
              overflow: '',
              marginRight: ''
          });

        }

        
        this.$router.push({query: q}).catch(err => {})
      },
      deep: true
    }
  },
  data () {
    return {
      loading: true,
      dbAddr: '',
      syncHandler: undefined,
      remoteDB: undefined,
      localDB: undefined,
      nomedb: undefined,
      sincronizando: null,
      instrumentState: INSTRUMENT_STORE.state,
      logged: null,
      timeoutState: {}
    }
  },
  created () {
    //console.log('check login')
    window.DB_ADDR = 'https://procal.ipt.br/_couch/'
    this.checkLogin()
    /*
    var client = axios({
      method: 'get',
      url: window.DB_ADDR
    })
    .then((response) => {
      //console.log(response)
    })
    .catch((error) => {
      console.log('definindo configuracao alternativa.')
      window.DB_ADDR = 'https://procal.ipt.br/_couch/'
    })
    .finally(() => {
      this.checkLogin()
    })*/
    
  },
  mounted () {
// Non-Sucking Cookie Consent
(function () {
let consent = window.localStorage.getItem('ns-cookie-consent')
if (!consent) {
  let banner = document.createElement('SPAN')
  banner.innerHTML = 'Este site utiliza cookies para seu correto funcionamento. Ao continuar nesta página, consideramos que você concorda com a utilização de cookies &nbsp;'
  ;[
    ['width', '100%'],
    ['position', 'fixed'],
    ['background', '#333333f6'],
    ['padding', '10px 0'],
    ['color', '#fff'],
    ['bottom', 0],
    ['padding', '18px'],
    ['margin-right', '12px'],
    ['font-size', '18px']
  ].forEach(x => banner.style[x[0]] = x[1])
  document.body.appendChild(banner)

  let button = document.createElement('BUTTON')
  button.innerHTML = 'Ok, entendi.'
  ;[
    ['color', '#fff'],
    ['background-color', '#000'],
    ['border-radius', '10px'],
    ['border', '1px'],
    ['-webkit-transition-duration', '0.4s'],
    ['transition-duration', '0.4s'],
    ['cursor', 'pointer'],
    ['font-size', '22px']
  ].forEach(x => button.style[x[0]] = x[1])

  ;['mouseover', 'mouseleave'].forEach(evtType => button.addEventListener(evtType, (evt) => {
    evt.type === 'mouseover' ? evt.target.style['background-color'] = '#005a8e' : evt.target.style['background-color'] = '#000'
  }))
  button.addEventListener('click', () => window.localStorage.setItem('ns-cookie-consent', '1')||button.remove()||banner.remove())
  banner.appendChild(button)
}}());
  },
  methods: {
    checkLogin () {
      // Checa login
      var loginDB = new PouchDB(window.DB_ADDR + '_users', {skip_setup: true, ajax: {timeout: 5000}})
      
      loginDB.getSession( (err, response) => {
        var userCtx
        if (err || !response.userCtx.name) {
          // console.log(err, response)
          // offline ou nobody's logged in
          this.nomedb = window.localStorage.getItem('nomedb')
          try {
            userCtx = JSON.parse(window.localStorage.getItem('userCtx'))
            if (this.nomedb && userCtx) {
              this.logged = true
            }
          } catch (err2) {
            console.log(err2)
          }
        } else {
          window.localStorage.setItem('userCtx', JSON.stringify(response.userCtx))
          userCtx = response.userCtx
          this.logged = true
          // TODO: Verificar em todas as roles e de forma mais robusta
          const sep = '__'
          var re = /(__{1})(?!.*__)/g;
          var _array = re.exec(userCtx.roles[0])
          const indiceSep = re.lastIndex - sep.length

          this.nomedb = userCtx.roles[0].substring(0, indiceSep)
          window.localStorage.setItem('nomedb', this.nomedb)
        }
        //this.remoteDB = new PouchDB(window.DB_ADDR + this.nomedb, {skip_setup: true, ajax: {timeout: 5000}})

        this.remoteDB = new PouchDB(window.DB_ADDR + this.nomedb, {
          skip_setup: true, ajax: {timeout: 5000},
          fetch(url, opts) {
            opts.credentials='include'
            return PouchDB.fetch(url, opts)
          }
        }).on('error', (err) => {
          console.log(err)
          //debugger;
        })

        INSTRUMENT_STORE.remoteDB = this.remoteDB

        if (!userCtx || !this.nomedb) {
          // sem usuario registrado previamente 
          this.loading = false
          //if (!this.logged && !this.$route.query.token) {
          //}
          if (this.$route.query.action === 'login') {
            this.instrumentState.isLanding = false
          } else {
            this.instrumentState.isLanding = true
          }
          return
        }
        
        INSTRUMENT_STORE.state.userCtx = userCtx
        INSTRUMENT_STORE.state.usuarioTemAdminRole = userCtx.roles[0].indexOf('__admin') !== -1
        INSTRUMENT_STORE.state.usuarioGerencia = (['cli-demo__admin'].indexOf(userCtx.roles[0]) !== -1) ||
          (userCtx.name.indexOf('@ipt.br') !== -1) ||
          (userCtx.roles[0] === this.nomedb+'__admin')
        ;

        // Problemas com iOS e pouchdb. para estes casos, usar apenas db remoto
        // e caso nao esteja conectaco, redirecionar para login
        //var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
        //if (iOS) {
        /*
        if (false) {
          console.log('iOS')
          if (!this.logged) {
            this.loading = false
            return
          }
          INSTRUMENT_STORE.state.db = this.remoteDB
        } else {
          //console.log(this.nomedb)
          this.localDB = new PouchDB(this.nomedb, {skip_setup: true, adapter: 'idb', auto_compaction: true})
          INSTRUMENT_STORE.state.db = this.localDB
        }
        */
        this.localDB = new PouchDB(this.nomedb, {skip_setup: true, adapter: 'idb', auto_compaction: true}).on('error', (err) => {
          console.log(err)
          //debugger;
        });
        
        // solucionando lentidao do map/reduce https://pouchdb.com/guides/queries.html
        /*
        this.loading = true
        this.localDB.query('analise/analise', {
          limit: 0 // don't return any results
        }).then(function (res) {
          console.log('index was built.')
        }).catch(function (err) {
          //
        }).finally(() => {
          this.loading = false
        });*/

        INSTRUMENT_STORE.state.db = this.localDB

        
        if (this.localDB && this.remoteDB && (this.localDB.adapter !== this.remoteDB.adapter)) {
          window.setTimeout(() => {
            this.setSync()
          }, 1000)
        }

        if (this.logged) {
          this.getAnaliseFn();
          this.queryInstrumentosData()
          .then(() => {
            if (!this.$route.params.id) {
              //this.$router.push({ path: '/instrumentos' }).catch(err => {})
              document.title = 'ProCal'// + complementoPageView()
            } else {
              //console.log(this.$route)
            }
            this.loading = false
          })
        }
      })
    },
    getAnaliseFn (db) {
      INSTRUMENT_STORE.state.Analises = Analises;

      
      // inspeciona objeto para obter funções disponíveis
      var analises = new INSTRUMENT_STORE.state.Analises({config: []}, true);
      var codCli = INSTRUMENT_STORE.state.userCtx.roles[0].split('__')[0];

      INSTRUMENT_STORE.state.funcoes = JSON.parse(JSON.stringify(analises.funcoes));

      if (codCli === 'cli-508') { // LME mantem todas as analises existentes
        INSTRUMENT_STORE.state.funcoes = JSON.parse(JSON.stringify(analises.funcoes));
      } else if (codCli === 'cli-95') { // Volks 
        INSTRUMENT_STORE.state.funcoes = JSON.parse(JSON.stringify(analises.funcoes));
        delete INSTRUMENT_STORE.state.funcoes['somaQuadUEMAMaisE'];
      } else { // por padrão, apenas Certificado de calibração e personalizado
        delete INSTRUMENT_STORE.state.funcoes['somaQuadUEMAMaisE'];
        delete INSTRUMENT_STORE.state.funcoes['AvaliacaoVolks'];
      }
      
    },
    queryInstrumentosData (db) {
      // define informações que devem aparecer na lista inicial
      var targetdb = db || INSTRUMENT_STORE.state.db
      return targetdb.query('instrumentos/lista').then( (data) => {
        var docsConfig = data.rows.filter((item) => item.id.indexOf('_config_') !== -1)
        var docsChecagem = data.rows.filter((item) => item.value.dataDaChecagem && item.value.dataDaProximaChecagem)
        var docsInst = data.rows.filter((item) => !!item.value.dataUltimaCal)
        var instrumentos = {}
        docsInst.map((inst) => {
          var configPeriodicidadeResArr = docsConfig
            .filter((conf) => conf.key[0] === inst.id)
            .map((conf) => {return conf.value})
          ;

          var configPeriodicidade = fnConfigPeriodicidade(
            configPeriodicidadeResArr, inst.value.AlPeriodoCalibracao, inst.value.AlTipoPeriodo
          )
          
          var status = fnPegaStatus(inst.value.dataUltimaCal, configPeriodicidade)

          var docsChecagemResArr = docsChecagem
            .filter((conf) => conf.key[0] === inst.id)
            .map((conf) => {return conf.value})
          ;
          
          var statusChecagem = fnPegaStatusChecagem(docsChecagemResArr)
          
          this.$set(instrumentos, inst.id, {
            status: status,
            statusChecagem: statusChecagem,
            descricao: fnDescItem(inst.value),
            item: inst.value,
            id: inst.id,
            configPeriodicidade: configPeriodicidade 
          })
          
          /*instrumentos[inst.id] = {
            status: status,
            descricao: fnDescItem(inst.value),
            item: inst.value,
            id: inst.id
          }*/
        })
        INSTRUMENT_STORE.updateInstrumentos(instrumentos)
              
      }).catch( (err) => {
        // some error
        if (err.reason === 'missing') {
          return this.queryInstrumentosData(this.remoteDB)
        } else {
          console.log(err)
        }
      });
    },
    queryInstIdData: fnQueryInstIdData,
    setSync () {
      var syncHandler = PouchDB.sync(this.localDB, this.remoteDB, {
        live: true,
        retry: true,
        filter: 'suprimeAnexos/suprimeAnexos'
      }).on('change', (data) => {
        var change = data.change
        if (change.docs.length) {
          //this.queryInstrumentosData()
          // Debounce a consulta da lista dos instrumentos
          var listaTimeoutId = this.timeoutState['_lista']
          if (listaTimeoutId) {
            clearTimeout(listaTimeoutId)
          }
          this.timeoutState['_lista'] = setTimeout(() => {
            this.queryInstrumentosData()
          }, 500)

          
          for (var i = 0; i < change.docs.length; i++) {

            if (('config_'+this.$route.params.id === change.docs[i].type) || ('ocorr_'+this.$route.params.id === change.docs[i].type) || change.docs[i]._id === this.$route.params.id) {
              // Debounce a consulta
              var timeoutId = this.timeoutState[this.$route.params.id]
              if (timeoutId) {
                clearTimeout(timeoutId)
              }
              this.timeoutState[this.$route.params.id] = setTimeout(() => {
                this.queryInstIdData()
              }, 500)
            }
          }
          
        }
      }).on('paused', (err) => {
        this.sincronizando = false
        console.log('sync paused')
        // replication paused (e.g. replication up to date, user went offline)
      }).on('active', () => {
        console.log('sync active')
        this.sincronizando = true
        // replicate resumed (e.g. new changes replicating, user went back online)
      }).on('denied', (err) => {
        console.log('denied', err)
        // a document failed to replicate (e.g. due to permissions)
      }).on('complete', (info) => {
        this.sincronizando = false
        console.log('sync complete')
        // handle complete
      }).on('error', (err) => {
        console.log('err', err)
        // handle error
      })
    }
  },
  computed: {
    temModalAberto () {
      var modals = this.instrumentState.modals
      return Object.keys(modals).reduce((acc, curr ) => {return acc || modals[curr]}, false)
    }
  }
}
</script>
<style>
@import '../node_modules/bulma/css/bulma.min.css';
@import '../node_modules/bulma-timeline/dist/css/bulma-timeline.min.css';
@import '../node_modules/bulma-switch/dist/css/bulma-switch.min.css';
@import '../node_modules/bulma-divider/dist/css/bulma-divider.min.css';


.tag, .notification, .button, input, select, .navbar-dropdown {
  border-radius: 0px !important;
}


.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}


/* PDF Viewer */

#pdf-container {
  width: 99%; 
  margin: 0 auto; 
  margin-top: 10px;
  position: relative;
  height: 50%;
}

#pdf-loading-container {
  margin-top: 20px;
  width: 99%;
  display: block;
  position: absolute;
}

.help-btn {
  margin-right: 8px;
}

.titulo-grafico-alinhado-com-controles {
  align-items: flex-end;
}

.adiciona-gap-entre-graficos {
  margin: 2px;
}

/* Font */

html, body {
  font-family: Roboto,Helvetica,Arial,sans-serif;
  background: #f9fafc !important;
  background-color: #f9fafc !important;
}

.navbar {
  -webkit-box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
  box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
}

.navbar.is-link .navbar-link:hover, .navbar-brand>a.navbar-item.is-active, .navbar.is-link .navbar-brand>a.navbar-item:hover {
  background-color: rgb(50, 65, 87) !important;
  color: #fff;
}

.padding-zero {
  padding: 0 !important;
}

pre {
  color: #606266;
  margin: 4px;
  background-color: #f5f7fa;
  font-family: Consolas,Menlo,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New,monospace,serif;
  max-height: 600px;
  overflow: auto;
  padding: 2px;
  width: auto;
}

.box{
  border-radius: 0px !important;
}


.formula-pre {
  user-select: all;
  background-color: #f5f7fa !important;
}



@media screen and (max-width: 580px) {
  table tr {
    padding: 0px 0 7px;
    display: block;
  }
  table tr th {
    padding: 0;
    height: 6px;
  }
  table th, table thead {
    display: none;
  }
  table tr td {
    padding: 1px .5em !important;
    margin-bottom: 10px;
    display: flex;
    flex-flow: column;

  }
  table tr td:before {
    margin-bottom: 3px;
    content: attr(data-title);
    min-width: 98px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    color: #969696;
    display: block;

  }

  .table tbody tr:last-child td, .table tbody tr:last-child th {
    border-bottom-width: thin !important; /* sobreescreve bulma*/
  }

}

@media screen and (max-width: 400px) {
  .ajusta-tamanho {
    font-size: 0.8em;
    padding-left: 2px;
  }
  .certificadoList {
    width: 150px;
  }
}


/* sobreescreve bulma */
.label:not(:last-child) {
  margin-bottom: -0.2em !important;
  font-size: 0.9em;
  font-weight: 100;
}

/* Estilos do nav bar para imitar o ProCal antigo*/
.navbar {
  border-radius: 0em;
  background-color: rgb(50, 65, 87) !important;
}

@media screen and (min-width: 1088px) {
  .navbar.is-link .navbar-end>a.navbar-item.is-active {
    color: rgb(32, 160, 255) !important;
    background-color: rgb(50, 65, 87) !important;
    border-bottom-color: rgb(32, 160, 255);
    border-bottom: 2px solid #409eff;
    padding-bottom: 6px;
  }
  .navbar.is-link .navbar-end>a.navbar-item:hover, .navbar.is-link .navbar-end .navbar-link:hover, .navbar.is-link .navbar-item.has-dropdown:hover .navbar-link {
    background-color: rgb(40, 52, 70) !important;
  }
}


.message {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border: 1px solid #d1dbe5;
}

.message-header p {
  font-weight: 100;
}

.help-modal-content {
  font-size: 0.9em;
}
.help-modal-content p {
  padding: 12px;
}

.help-modal-content li {
  list-style: initial !important;
}

.help-modal-content ul {
  padding-left: 20px;
}

.abre-ajuda {
  cursor: pointer !important;
}

/* Modal styles */

.modal{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;visibility:hidden}.modal .modal-background{-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s;opacity:0}.modal.is-active{visibility:visible}.modal.is-active .modal-background{opacity:1}.modal.modal-full-screen .modal-background{background-color:#fff}.modal.modal-full-screen .modal-content{width:100%;height:100%;max-height:100vh;margin:0;background-color:#fff}.modal.modal-fx-fadeInScale .modal-content{-webkit-transform:scale(.7);-o-transform:scale(.7);transform:scale(.7);opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-fadeInScale.is-active .modal-content{-webkit-transform:scale(1);-o-transform:scale(1);transform:scale(1);opacity:1}.modal.modal-fx-slideRight .modal-content{-webkit-transform:translateX(20%);-o-transform:translateX(20%);transform:translateX(20%);opacity:0;-webkit-transition:all .3s cubic-bezier(.25,.5,.5,.9);-o-transition:all .3s cubic-bezier(.25,.5,.5,.9);transition:all .3s cubic-bezier(.25,.5,.5,.9)}.modal.modal-fx-slideRight.is-active .modal-content{-webkit-transform:translateX(0);-o-transform:translateX(0);transform:translateX(0);opacity:1}.modal.modal-fx-slideLeft .modal-content{-webkit-transform:translateX(-20%);-o-transform:translateX(-20%);transform:translateX(-20%);opacity:0;-webkit-transition:all .3s cubic-bezier(.25,.5,.5,.9);-o-transition:all .3s cubic-bezier(.25,.5,.5,.9);transition:all .3s cubic-bezier(.25,.5,.5,.9)}.modal.modal-fx-slideLeft.is-active .modal-content{-webkit-transform:translateX(0);-o-transform:translateX(0);transform:translateX(0);opacity:1}.modal.modal-fx-slideBottom .modal-content{-webkit-transform:translateY(20%);-o-transform:translateY(20%);transform:translateY(20%);opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-slideBottom.is-active .modal-content{-webkit-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0);opacity:1}.modal.modal-fx-slideTop .modal-content{-webkit-transform:translateY(-20%);-o-transform:translateY(-20%);transform:translateY(-20%);opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-slideTop.is-active .modal-content{-webkit-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0);opacity:1}.modal.modal-fx-fall.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-fall .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translateZ(600px) rotateX(20deg);transform:translateZ(600px) rotateX(20deg);opacity:0}.modal.modal-fx-fall.is-active .modal-content{-webkit-transition:all .3s ease-in;-o-transition:all .3s ease-in;transition:all .3s ease-in;-webkit-transform:translateZ(0) rotateX(0);transform:translateZ(0) rotateX(0);opacity:1}.modal.modal-fx-slideFall.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-slideFall .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translate(30%) translateZ(600px) rotate(10deg);transform:translate(30%) translateZ(600px) rotate(10deg);opacity:0}.modal.modal-fx-slideFall.is-active .modal-content{-webkit-transition:all .3s ease-in;-o-transition:all .3s ease-in;transition:all .3s ease-in;-webkit-transform:translate(0) translateZ(0) rotate(0);transform:translate(0) translateZ(0) rotate(0);opacity:1}.modal.modal-fx-newsPaper .modal-content{-webkit-transform:scale(0) rotate(720deg);-o-transform:scale(0) rotate(720deg);transform:scale(0) rotate(720deg);opacity:0}.modal.modal-fx-newsPaper .modal-background,.modal.modal-fx-newsPaper .modal-content{-webkit-transition:all .7s;-o-transition:all .7s;transition:all .7s}.modal.modal-fx-newsPaper.is-active .modal-content{-webkit-transform:scale(1) rotate(0);-o-transform:scale(1) rotate(0);transform:scale(1) rotate(0);opacity:1}.modal.modal-fx-3dFlipVertical.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dFlipVertical .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:rotateX(-70deg);transform:rotateX(-70deg);-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s;opacity:0}.modal.modal-fx-3dFlipVertical.is-active .modal-content{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}.modal.modal-fx-3dFlipHorizontal.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dFlipHorizontal .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:rotateY(-70deg);transform:rotateY(-70deg);-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s;opacity:0}.modal.modal-fx-3dFlipHorizontal.is-active .modal-content{-webkit-transform:rotateY(0);transform:rotateY(0);opacity:1}.modal.modal-fx-3dSign.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dSign .modal-content{position:relative;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:rotateX(-60deg);transform:rotateX(-60deg);-webkit-transform-origin:50% 0;-o-transform-origin:50% 0;transform-origin:50% 0;opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-3dSign.is-active .modal-content{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}.modal.modal-fx-3dSignDown.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dSignDown .modal-content{position:relative;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:rotateX(60deg);transform:rotateX(60deg);-webkit-transform-origin:0 100%;-o-transform-origin:0 100%;transform-origin:0 100%;opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-3dSignDown.is-active .modal-content{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}.modal.modal-fx-superScaled .modal-content{-webkit-transform:scale(2);-o-transform:scale(2);transform:scale(2);opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-superScaled.is-active .modal-content{-webkit-transform:scale(1);-o-transform:scale(1);transform:scale(1);opacity:1}.modal.modal-fx-3dSlit.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dSlit .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translateZ(-3000px) rotateY(90deg);transform:translateZ(-3000px) rotateY(90deg);opacity:0}.modal.modal-fx-3dSlit.is-active .modal-content{-webkit-animation:slit .5s forwards ease-out;-o-animation:slit .5s forwards ease-out;animation:slit .5s forwards ease-out}@-webkit-keyframes slit{50%{-webkit-transform:translateZ(-250px) rotateY(89deg);transform:translateZ(-250px) rotateY(89deg);opacity:1;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}100%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0);opacity:1}}@-o-keyframes slit{50%{transform:translateZ(-250px) rotateY(89deg);opacity:1;-o-animation-timing-function:ease-in;animation-timing-function:ease-in}100%{transform:translateZ(0) rotateY(0);opacity:1}}@keyframes slit{50%{-webkit-transform:translateZ(-250px) rotateY(89deg);transform:translateZ(-250px) rotateY(89deg);opacity:1;-webkit-animation-timing-function:ease-in;-o-animation-timing-function:ease-in;animation-timing-function:ease-in}100%{-webkit-transform:translateZ(0) rotateY(0);transform:translateZ(0) rotateY(0);opacity:1}}.modal.modal-fx-3dRotateFromBottom.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dRotateFromBottom .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translateY(100%) rotateX(90deg);transform:translateY(100%) rotateX(90deg);-webkit-transform-origin:0 100%;-o-transform-origin:0 100%;transform-origin:0 100%;opacity:0;-webkit-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.modal.modal-fx-3dRotateFromBottom.is-active .modal-content{-webkit-transform:translateY(0) rotateX(0);transform:translateY(0) rotateX(0);opacity:1}.modal.modal-fx-3dRotateFromLeft.modal{-webkit-perspective:1300px;perspective:1300px}.modal.modal-fx-3dRotateFromLeft .modal-content{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translateZ(100px) translateX(-30%) rotateY(90deg);transform:translateZ(100px) translateX(-30%) rotateY(90deg);-webkit-transform-origin:0 100%;-o-transform-origin:0 100%;transform-origin:0 100%;opacity:0;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}.modal.modal-fx-3dRotateFromLeft.is-active .modal-content{-webkit-transform:translateZ(0) translateX(0) rotateY(0);transform:translateZ(0) translateX(0) rotateY(0);opacity:1}.modal .modal-content.is-huge{width:100%;margin:0 20px;max-height:calc(100vh - 40px)}@media screen and (min-width:769px){.modal .modal-content.is-huge{width:100%;margin:0 20px;max-height:calc(100vh - 40px)}}.modal .modal-content.is-tiny{max-width:400px}.modal .modal-content.is-image{text-align:center}.modal .modal-content.is-image.is-huge{width:auto}.modal .modal-content.is-image img{max-height:calc(100vh - 50px)}.modal.modal-pos-top{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.modal.modal-pos-top .modal-content{margin-top:1rem}.modal.modal-pos-bottom{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.modal.modal-pos-bottom .modal-content{margin-bottom:1rem}.modal .modal-background{background-color:rgba(10,10,10,.86)}

/* Scroll style */

::-webkit-scrollbar {
    width: 10px;
}
::-webkit-scrollbar-track {
    background: #FFF;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0,0,0,0.1);
}
::-webkit-scrollbar-thumb {
    border-radius: 0px;
    background: #CCC;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0,0,0,0.2);
}
::-webkit-scrollbar-thumb:hover {
    border-radius: 0px;
    background: #AAA;
}
::-webkit-scrollbar-thumb:active {
    border-radius: 0px;
    background: #888;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0,0,0,0.3);
}

.filtro-instrumentos-tabs a {
  padding: .5em 0.7em;
}

/* Landing */
.landing-el.content-wrapper {
  background: white;
}

.landing-el .rotate-180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}    

.landing-el .hero.is-large .hero-body {
    padding-bottom: 0;
    padding-top: 5rem;
}
.landing-el .hero figure {
    height: 0;
    padding-bottom: 55%;
    overflow: hidden;
}
.landing-el figure {
/*  padding-left: 50px;
  padding-right: 50px;*/
}
.landing-el .bg-white {
    background-color: #ffffff;
}
.landing-el .bg-light {
    background-color: #faf6fb;
}
.landing-el .media-left {
    padding-left: 15px;
}
.landing-el .media-left .icon {
    margin-top: 15px;

}

.landing-el .media-content {
    padding-left: 25px;
}

.landing-el .media {
    background-color: #ffffff;
    padding: 25px;
}

.landing-el .section {
  /*padding: 7rem 5rem;*/
}

.landing-el .content h1 {
    margin-bottom: 2em;
}

#stn-download {
    color: #ffffff;
    background-image: linear-gradient( 135deg, rgb(255, 255, 255) 0%, rgb(210, 218, 230) 100%);
}

.landing-el .hero.is-landing {
    color: #ffffff;
    background-image: linear-gradient( 135deg, rgb(255, 255, 255) 0%, rgb(210, 218, 230) 100%);
}

.landing-el .hero.is-landing * {
    color: #ffffff;
}

#stn-download h1 {
    color: #ffffff;
}

.landing-el .button.button-store {
    border-radius: 3px;
    background: #FFF;
    box-shadow: 0px 9px 32px 0px rgba(0, 0, 0, 0.26);
    font-size: 14px;
    
    color: #633991;
    margin: 0.5rem;
    padding: 0.7rem 1.6rem;
    line-height: 1.8;
    height: auto;
    text-transform: uppercase;
    transition: all 0.3s ease;

    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
}

.landing-el .button.button-store:hover {
    color: #000000;
    background-color: #faf6fb;
}

.landing-el .button.button-store img {
    margin-right: 0.4rem;
    vertical-align: text-bottom;
}

.sync-girando {
  -webkit-animation: spin 1s linear infinite !important;
  -moz-animation: spin 1s linear infinite !important;
  animation: spin 1s linear infinite !important;
  width: 50px;
}

@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

</style>
